import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape, FormattedMessage } from 'react-intl';

import LibraryItem from '../../containers/library-item.jsx';
import Modal from '../../containers/modal.jsx';
import Divider from '../divider/divider.jsx';
import Filter from '../filter/filter.jsx';
import TagButton from '../../containers/tag-button.jsx';
import Spinner from '../spinner/spinner.jsx';
import storage from '../../lib/storage';
import CourseItem from '../course-item/course-item.jsx';
// import tojsondata from '../../lib/libraries/sb3-file/index.js';

import Scratchblocks from 'scratch-blocks';
import styles from './library.css';
import { forEach } from 'lodash';
import { setCourse } from '../../reducers/mode.js';


if (window.require != undefined) {
    var ipcRenderer = window.require('electron').ipcRenderer;
}

const messages = defineMessages({
    filterPlaceholder: {
        id: 'gui.library.filterPlaceholder',
        defaultMessage: 'Search',
        description: 'Placeholder text for library search field'
    },
    allTag: {
        id: 'gui.library.allTag',
        defaultMessage: 'All',
        description: 'Label for library tag to revert to all items after filtering by tag.'
    }
});

const ALL_TAG = { tag: 'all', intlLabel: messages.allTag };
const tagListPrefix = [ALL_TAG];

/**
 * Find the AssetType which corresponds to a particular file extension. For example, 'png' => AssetType.ImageBitmap.
 * @param {string} fileExtension - the file extension to look up.
 * @returns {AssetType} - the AssetType corresponding to the extension, if any.
 */
const getAssetTypeForFileExtension = function (fileExtension) {
    const compareOptions = {
        sensitivity: 'accent',
        usage: 'search'
    };
    for (const assetTypeId in storage.AssetType) {
        const assetType = storage.AssetType[assetTypeId];
        if (fileExtension.localeCompare(assetType.runtimeFormat, compareOptions) === 0) {
            return assetType;
        }
    }
};

/**
 * Figure out an `imageSource` (URI or asset ID & type) for a library item's icon.
 * @param {object} item - either a library item or one of a library item's costumes.
 * @returns {object} - an `imageSource` ready to be passed to a `ScratchImage`.
 */
const getItemImageSource = function (item) {
    if (item.rawURL) {
        return {
            uri: item.rawURL
        };
    }

    // TODO: adjust libraries to be more storage-friendly; don't use split() here.
    const md5ext = item.md5 || item.baseLayerMD5;
    if (md5ext) {
        const [assetId, fileExtension] = md5ext.split('.');
        return {
            assetId: assetId,
            assetType: getAssetTypeForFileExtension(fileExtension)
        };
    }
};

const getCourseData = function (props) {
    let courseData = props.course
    if (!props.vm || Object.keys(courseData).length === 0) {
        return {}
    }
    let lang = props.intl.locale
    let robotType = props.vm.robotType
    let data = courseData["E6"]["zh-cn"]
    try {
        courseData[robotType][lang] && (data = courseData[robotType][lang])
    } catch (err) {
        data = courseData["E6"]["zh-cn"]
    }
    console.log(data)
    return data
}

class LibraryComponent extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleClose',
            'handleFilterChange',
            'handleFilterClear',
            'handleMouseEnter',
            'handleMouseLeave',
            'handlePlayingEnd',
            'handleSelect',
            'handleTagClick',
            'setFilteredDataRef',
            'fileSB3',
            'handleTipsTagClick',
            'getTagTipsList',
            'getTag'
        ]);
        this.state = {
            playingItem: null,
            filterQuery: '',
            selectedTag: ALL_TAG.tag,
            courseTag: 'default',
            loaded: false,
            courseData: {}
        };
    }
    componentDidMount() {
        // Allow the spinner to display before loading the content
        setTimeout(() => {

            this.setState({
                loaded: true,
                courseData: getCourseData(this.props)
            });

            if (this.props.course &&
                this.props.course[this.props.vm.robotType] &&
                this.props.course[this.props.vm.robotType][this.props.intl.locale]) {
                Object.keys(this.props.course[this.props.vm.robotType][this.props.intl.locale]).sort().reverse().map((item, index) => {
                    if (index === 0) {
                        this.setState({
                            courseTag: item
                        })
                    }
                })
            }

        });
        if (this.props.setStopHandler) this.props.setStopHandler(this.handlePlayingEnd);

        // if (ipcRenderer && this.props.course && Object.keys(this.props.course).length === 0) {
        //     ipcRenderer.send('getSourse')
        // }

    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.filterQuery !== this.state.filterQuery ||
            prevState.selectedTag !== this.state.selectedTag) {
            this.scrollToTop();
        }
    }
    handleSelect(id) {
        this.handleClose();
        this.props.onItemSelected(this.getFilteredData()[id]);
    }
    handleClose() {
        this.props.onRequestClose();
    }
    handleTagClick(tag) {
        if (this.state.playingItem === null) {
            this.setState({
                filterQuery: '',
                selectedTag: tag.toLowerCase()
            });
        } else {
            this.props.onItemMouseLeave(this.getFilteredData()[[this.state.playingItem]]);
            this.setState({
                filterQuery: '',
                playingItem: null,
                selectedTag: tag.toLowerCase()
            });
        }
    }
    handleMouseEnter(id) {
        // don't restart if mouse over already playing item
        if (this.props.onItemMouseEnter && this.state.playingItem !== id) {
            this.props.onItemMouseEnter(this.getFilteredData()[id]);
            this.setState({
                playingItem: id
            });
        }
    }
    handleMouseLeave(id) {
        if (this.props.onItemMouseLeave) {
            this.props.onItemMouseLeave(this.getFilteredData()[id]);
            this.setState({
                playingItem: null
            });
        }
    }
    handlePlayingEnd() {
        if (this.state.playingItem !== null) {
            this.setState({
                playingItem: null
            });
        }
    }
    handleFilterChange(event) {
        if (this.state.playingItem === null) {
            this.setState({
                filterQuery: event.target.value,
                selectedTag: ALL_TAG.tag
            });
        } else {
            this.props.onItemMouseLeave(this.getFilteredData()[[this.state.playingItem]]);
            this.setState({
                filterQuery: event.target.value,
                playingItem: null,
                selectedTag: ALL_TAG.tag
            });
        }
    }
    handleFilterClear() {
        this.setState({ filterQuery: '' });
    }
    getFilteredData() {
        if (this.state.selectedTag === 'all') {
            if (!this.state.filterQuery) return this.props.data;
            return this.props.data.filter(dataItem => (
                (dataItem.tags || [])
                    // Second argument to map sets `this`
                    .map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
                    .concat(dataItem.name ?
                        (typeof dataItem.name === 'string' ?
                            // Use the name if it is a string, else use formatMessage to get the translated name
                            dataItem.name : this.props.intl.formatMessage(dataItem.name.props)
                        ).toLowerCase() :
                        null)
                    .join('\n') // unlikely to partially match newlines
                    .indexOf(this.state.filterQuery.toLowerCase()) !== -1
            ));
        }
        return this.props.data.filter(dataItem => (
            dataItem.tags &&
            dataItem.tags
                .map(String.prototype.toLowerCase.call, String.prototype.toLowerCase)
                .indexOf(this.state.selectedTag) !== -1
        ));
    }
    scrollToTop() {
        this.filteredDataRef.scrollTop = 0;
    }
    setFilteredDataRef(ref) {
        this.filteredDataRef = ref;
    }
    fileSB3(item) {
        if (ipcRenderer) {
            const fs = window.require('electron').remote.require("fs")
            fs.readFile(item.url, (err, data) => {
                if (err) {
                    console.log(err)
                    return
                }
                this.props.vm.loadProject(data)
                    .then(() => {
                        window.__yourReactComp__.props.onUpdateProjectTitle(item.title)
                        var code = document.getElementById('codeSmallBtn')
                        code.style.display = 'block';
                        this.props.clickToBlockpanel()
                        this.props.btnFalse()
                        this.props.onActiveTab()
                        this.props.setStateFalse('showStage')
                        this.props.onRequestClose()
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'));
                        }, 0)
                    })
            })
        }
        // this.props.vm.loadProject(item.course)
        //     .then(() => {
        //         window.__yourReactComp__.props.onUpdateProjectTitle(item.title)
        //         var code = document.getElementById('codeSmallBtn')
        //         code.style.display = 'block';
        //         this.props.clickToBlockpanel()
        //         this.props.btnFalse()
        //         this.props.onActiveTab()
        //         this.props.setStateFalse('showStage')
        //         this.props.onRequestClose()
        //         setTimeout(() => {
        //             window.dispatchEvent(new Event('resize'));
        //         }, 0)
        //     })
    }
    handleTipsTagClick(tag) {
        this.setState({
            courseTag: tag
        })
    }
    getTag() {
        let data = Object.keys(this.state.courseData).map((item, index) => {
            return {
                tag: item
            }
        })
        return data
    }
    getTagTipsList() {
        if (Object.keys(this.state.courseData).length === 0) {
            return []
        }
        let data = this.state.courseData["默认"]

        try {
            this.state.courseData[this.state.courseTag] && (data = this.state.courseData[this.state.courseTag])
        } catch (err) {
            data = this.state.courseData["默认"]
        }
        data = Object.keys(data).map((item) => {
            return data[item]
        })
        return data
    }
    render() {
        const {
            course,
            intl,
            vm
        } = this.props
        const renderCourse = () => {
            if (course &&
                course[vm.robotType] &&
                course[vm.robotType][intl.locale] &&
                course[vm.robotType][intl.locale][this.state.courseTag]) {
                return course[vm.robotType][intl.locale][this.state.courseTag].map((item, index) => (
                    <CourseItem
                        key={index}
                        num={index}
                        data={item}
                        fileSB3={this.fileSB3}
                    />

                ))
            } else {
                return null
            }
        }

        const getTag = () => {
            if (course &&
                course[vm.robotType] &&
                course[vm.robotType][intl.locale]) {
                let data = Object.keys(course[vm.robotType][intl.locale]).sort().reverse().map((item) => {
                    return {
                        tag: item
                    }
                })
                return data
            } else {
                return []
            }
        }
        return (
            <Modal
                fullScreen
                contentLabel={this.props.title}
                id={this.props.id}
                onRequestClose={this.handleClose}
            >
                {(this.props.filterable || this.props.tags || this.props.visible) && (
                    this.props.visible ? null :
                        <div className={styles.filterBar}>
                            {this.props.filterable && (
                                <Filter
                                    className={classNames(
                                        styles.filterBarItem,
                                        styles.filter
                                    )}
                                    filterQuery={this.state.filterQuery}
                                    inputClassName={styles.filterInput}
                                    placeholderText={this.props.intl.formatMessage(messages.filterPlaceholder)}
                                    onChange={this.handleFilterChange}
                                    onClear={this.handleFilterClear}
                                />
                            )}
                            {this.props.filterable && this.props.tags && (
                                <Divider className={classNames(styles.filterBarItem, styles.divider)} />
                            )}
                            {this.props.tags &&
                                <div className={styles.tagWrapper}>
                                    {tagListPrefix.concat(this.props.tags).map((tagProps, id) => (
                                        <TagButton
                                            active={this.state.selectedTag === tagProps.tag.toLowerCase()}
                                            className={classNames(
                                                styles.filterBarItem,
                                                styles.tagButton,
                                                tagProps.className
                                            )}
                                            key={`tag-button-${id}`}
                                            onClick={this.handleTagClick}
                                            {...tagProps}
                                        />
                                    ))}
                                </div>
                            }
                        </div>
                )}
                {this.props.visible ? (
                    <div className={styles.tipContainer}>
                        <div className={styles.tipsfilterBar}>
                            <div className={styles.tipstagWrapper}>
                                {getTag().map((tagProps, id) => {
                                    return (
                                        // <TagButton
                                        //     active={this.state.selectedTag === tagProps.tag}
                                        //     // className={classNames(
                                        //     //     styles.filterBarItem,
                                        //     //     styles.tagButton,
                                        //     //     tagProps.className
                                        //     // )}
                                        //     key={`tag-button-${id}`}
                                        //     onClick={this.handleTipsTagClick}
                                        //     {...tagProps}
                                        // />
                                        <div
                                            className={classNames(
                                                styles.tiptagButton,
                                                { [styles.tipActive]: this.state.courseTag === tagProps.tag }
                                            )}
                                            key={`tag-button-${id}`}
                                            onClick={() => { this.handleTipsTagClick(tagProps.tag) }}
                                        >
                                            {tagProps.tag}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className={styles.robotCourse}
                            ref={this.setFilteredDataRef}>
                            {/* {this.getTagTipsList().map((item, index) => (
                                <CourseItem
                                    key={index}
                                    num={index}
                                    data={item}
                                    fileSB3={this.fileSB3}
                                />

                            ))} */}
                            {
                                renderCourse()
                            }
                        </div>
                    </div>
                ) : (
                    <div
                        className={classNames(styles.libraryScrollGrid, {
                            [styles.withFilterBar]: this.props.filterable || this.props.tags
                        })}
                        ref={this.setFilteredDataRef}
                    >
                        {this.state.loaded ? this.getFilteredData().map((dataItem, index) => {
                            if (dataItem.robotArray && !dataItem.robotArray.includes(Scratchblocks.getalls().type)) {
                                return
                            }
                            const iconSource = getItemImageSource(dataItem);
                            const icons = dataItem.json && dataItem.json.costumes.map(getItemImageSource);
                            return (<LibraryItem
                                bluetoothRequired={dataItem.bluetoothRequired}
                                collaborator={dataItem.collaborator}
                                description={dataItem.description}
                                disabled={dataItem.disabled}
                                extensionId={dataItem.extensionId}
                                featured={dataItem.featured}
                                hidden={dataItem.hidden}
                                iconSource={iconSource}
                                icons={icons}
                                id={index}
                                insetIconURL={dataItem.insetIconURL}
                                internetConnectionRequired={dataItem.internetConnectionRequired}
                                isPlaying={this.state.playingItem === index}
                                key={typeof dataItem.name === 'string' ? dataItem.name : dataItem.rawURL}
                                name={dataItem.name}
                                showPlayButton={this.props.showPlayButton}
                                onMouseEnter={this.handleMouseEnter}
                                onMouseLeave={this.handleMouseLeave}
                                onSelect={this.handleSelect}
                                onDeleteExtension={this.props.onDeleteExtension}
                                onRequestClose={this.props.onRequestClose}
                            />);
                        }) : (
                            <div className={styles.spinnerWrapper}>
                                <Spinner
                                    large
                                    level="primary"
                                />
                            </div>
                        )}
                    </div>)}
            </Modal>
        );
    }
}

LibraryComponent.propTypes = {
    data: PropTypes.arrayOf(
        /* eslint-disable react/no-unused-prop-types, lines-around-comment */
        // An item in the library
        PropTypes.shape({
            // @todo remove md5/rawURL prop from library, refactor to use storage
            md5: PropTypes.string,
            name: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node
            ]),
            rawURL: PropTypes.string
        })
        /* eslint-enable react/no-unused-prop-types, lines-around-comment */
    ),
    filterable: PropTypes.bool,
    id: PropTypes.string.isRequired,
    intl: intlShape.isRequired,
    onItemMouseEnter: PropTypes.func,
    onItemMouseLeave: PropTypes.func,
    onItemSelected: PropTypes.func,
    onRequestClose: PropTypes.func,
    setStopHandler: PropTypes.func,
    showPlayButton: PropTypes.bool,
    tags: PropTypes.arrayOf(PropTypes.shape(TagButton.propTypes)),
    title: PropTypes.string.isRequired
};

LibraryComponent.defaultProps = {
    filterable: true,
    showPlayButton: false
};

export default injectIntl(LibraryComponent);
